import React from 'react'
import closeIcon from "../assets/images/close.svg";

export default function ShowDocument(props:any) {
  return (
    <div className=" mx-auto my-auto text-14">
    <div className="border bg-white m-2 rounded document-box p-2">
      <div className="row mx-auto">
        <div className="col-12">
          <img src={closeIcon} className="show-cursor" alt="Close" title="Close" onClick={props.onDocumentCloseClick} />
        </div>
      </div>
    </div>
  </div>
  )
}
